import { Application } from '@hotwired/stimulus';
import TabsController from './tabs_controller.js';
import CartController from './cart_controller.js';
import LeadTableController from './lead_table_controller.js';
import PreviewController from './preview_controller.js';
import CatalogController from './catalog_controller.js';
import OrdersController from './orders_controller.js';
import ComplaintsController from './complaints_controller.js';
import CreditsController from './credits_controller.js';
import BackorderController from './backorder_controller.js';
import AuthLogController from './auth_log_controller.js';
import DashboardController from './dashboard_controller.js';
import PhoneVerifyController from './phone_verify_controller.js';
import AccountController from './account_controller.js';
import CrudController from './crud_controller.js';
import LeadAdminController from './lead_admin_controller.js';
import SubcategoryAdminController from './subcategory_admin_controller.js';
import StaffClientsController from './staff_clients_controller.js';
import ClientsKpiController from './clients_kpi_controller.js';

const application = Application.start();
application.register('tabs', TabsController);
application.register('cart', CartController);
application.register('lead-table', LeadTableController);
application.register('preview', PreviewController);
application.register('catalog', CatalogController);
application.register('orders', OrdersController);
application.register('complaints', ComplaintsController);
application.register('credits', CreditsController);
application.register('backorder', BackorderController);
application.register('auth-log', AuthLogController);
application.register('dashboard', DashboardController);
application.register('phone-verify', PhoneVerifyController);
application.register('account', AccountController);
application.register('crud', CrudController);
application.register('lead-admin', LeadAdminController);
application.register('subcategory-admin', SubcategoryAdminController);
application.register('staff-clients', StaffClientsController);
application.register('clients-kpi', ClientsKpiController);

export { application };
